import HelpIcon from "@mui/icons-material/HelpOutlineRounded";
import { Stack, Tooltip, Typography } from "@mui/material";
import MultilineTooltipTitle from "@entrilia/shared/components/MultilineTooltipTitle";

const tooltipLines = [
  "You have limited access based on entity-level permissions. Some data, such as funds or documents, may be hidden.",
  "To understand how this works, see the Entity-Level Access article.",
  "If you're unsure about this restriction, please contact your Organization Owner for more details.",
];

const RestrictedEntityLevelAccessMessage = () => {
  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
      <Typography component="span" variant="caption" sx={{ color: "action.active" }}>
        Entity-Level Access:
      </Typography>
      <Typography component="span" variant="caption" sx={{ color: "warning.light" }}>
        Restricted
      </Typography>
      <Tooltip arrow title={<MultilineTooltipTitle lines={tooltipLines} />}>
        <HelpIcon sx={(t) => ({ color: t.palette.action.active })} />
      </Tooltip>
    </Stack>
  );
};

export default RestrictedEntityLevelAccessMessage;
